module.exports = require("core-js-pure/stable/number/is-integer");